import { Select } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredRules } from '../../../../../../../../../../constants/forms/validation/rules'
import { stampShapes } from '../../../../../../../../../../constants/entity-enums/stamp-shapes'

interface ShapeProps {}

const Shape: FC<ShapeProps> = () => {
    const name = 'shape'

    return (
        <Form.Item name={name} label={'Форма'} rules={requiredRules}>
            <Select options={stampShapes.map(shape => ({ value: shape }))} />
        </Form.Item>
    )
}

export default Shape
